import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';

const FormationPage = () => {
  // Fonction pour obtenir le chemin des images
  const getImagePath = (fileName) => {
    if (!fileName || fileName.trim() === '') return null;
    
    const cleanName = fileName.trim();
    const extensions = ['.jpg', '.jpeg', '.png', '.webp', '.JPG', '.JPEG', '.PNG'];
    const hasExtension = extensions.some(ext => cleanName.endsWith(ext));
    
    if (hasExtension) {
      return `/assets/formation/${cleanName}`;
    } else {
      return `/assets/formation/${cleanName}.png`;
    }
  };

  return (
    <div style={styles.container}>
      <NavigationBar />
      
      <main style={styles.main}>
        {/* En-tête avec titre */}
        <header style={styles.header}>
          <h4 style={styles.title}>
            Formation sur l'inclusion statistique des populations déplacées de force financée par la Banque mondiale à travers le HCR
          </h4>
          <div style={styles.metaInfo}>
            <span style={styles.date}>10-16 Décembre 2025</span>
            <span style={styles.location}>Dakar & Yaoundé</span>
          </div>
        </header>

        {/* Section Formation à Dakar */}
        <section style={styles.section}>
          <p style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>01</span>
            Formation à Dakar (10-12 décembre 2025)
          </p>
          
          <p style={styles.paragraph}>
            Une délégation conduite par le Directeur général de l'Institut National de la Statistique du Burundi (INSBU) a pris part, du 10 au 12 décembre 2025 à Dakar, à une formation visant le renforcement des capacités des Instituts nationaux de statistique en matière d'inclusion statistique des populations déplacées de force dans les recensements et les enquêtes nationales.
          </p>
          
          <p style={styles.paragraph}>
            Cette formation a permis aux participants d'échanger sur les approches méthodologiques d'identification des populations déplacées de force dans les enquêtes auprès des ménages et les recensements, ainsi que sur les bonnes pratiques internationales en matière d'inclusion statistique.
          </p>
        </section>

        {/* Section Voyage d'étude au Cameroun */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>02</span>
            Voyage d'étude au Cameroun (15-16 décembre 2025)
          </h2>
          
          <p style={styles.paragraph}>
            À l'issue de cette activité, la délégation burundaise a effectué un voyage d'étude à l'Institut National de la Statistique du Cameroun du 15 au 16 décembre 2025.
          </p>
          
          {/* Photo de famille à l'INS Cameroun */}
          <div style={styles.photoContainer}>
            <img 
              src={getImagePath("photo_famille.png")} 
              alt="Photo de famille à l'INS Cameroun" 
              style={styles.mainPhoto}
            />
            <p style={styles.photoCaption}>
              Photo de famille de la délégation burundaise avec leurs homologues camerounais à l'INS Cameroun
            </p>
          </div>
    
          
          <p style={styles.paragraph}>
            L'ensemble de ces événements a contribué au renforcement des capacités des participants, à une meilleure appropriation des standards internationaux et au développement d'une collaboration plus structurée entre les Instituts nationaux de statistique et le HCR, tandis que les enseignements tirés, notamment de l'expérience camerounaise, constituent des acquis précieux pour l'amélioration future de l'inclusion des populations déplacées de force dans le système statistique national.
          </p>
        </section>

        {/* Section des acquis et bénéfices */}
        <section style={styles.benefitsSection}>
          <h2 style={styles.subtitle}>Acquis et bénéfices de la mission</h2>
          
          <div style={styles.benefitsGrid}>
            <div style={styles.benefitCard}>
              <div style={styles.benefitIcon}>📊</div>
              <h3 style={styles.benefitTitle}>Renforcement des capacités</h3>
              <p style={styles.benefitText}>
                Amélioration des compétences techniques en matière d'inclusion statistique des populations déplacées
              </p>
            </div>
            
            <div style={styles.benefitCard}>
              <div style={styles.benefitIcon}>🤝</div>
              <h3 style={styles.benefitTitle}>Collaboration renforcée</h3>
              <p style={styles.benefitText}>
                Développement d'une collaboration structurée entre l'INSBU, l'INS Cameroun et le HCR
              </p>
            </div>
            
            <div style={styles.benefitCard}>
              <div style={styles.benefitIcon}>🌍</div>
              <h3 style={styles.benefitTitle}>Standards internationaux</h3>
              <p style={styles.benefitText}>
                Appropriation des bonnes pratiques et standards internationaux en inclusion statistique
              </p>
            </div>
            
            <div style={styles.benefitCard}>
              <div style={styles.benefitIcon}>💡</div>
              <h3 style={styles.benefitTitle}>Retour d'expérience</h3>
              <p style={styles.benefitText}>
                Capitalisation sur l'expérience camerounaise pour améliorer les pratiques nationales
              </p>
            </div>
          </div>
        </section>

        {/* Section participants */}
        <section style={styles.participantsSection}>
          <h2 style={styles.subtitle}>Délégation de l'INSBU</h2>
          
          <div style={styles.participantsGrid}>
            <div style={styles.participantCard}>
              <div style={styles.participantInfo}>
                <h4 style={styles.participantCardName}>NDAYISHIMIYE Nicolas</h4>
                <p style={styles.participantCardRole}>Directeur Général de l'INSBU (chef de mission)</p>
              </div>
            </div>
            
            <div style={styles.participantCard}>
              <div style={styles.participantInfo}>
                <h4 style={styles.participantCardName}>NDAYISENGA Modeste</h4>
                <p style={styles.participantCardRole}>Directeur du Département de la Coordination, de la Diffusion et de la Coopération</p>
              </div>
            </div>
            
            <div style={styles.participantCard}>
              <div style={styles.participantInfo}>
                <h4 style={styles.participantCardName}>NDUWABIKE Noé</h4>
                <p style={styles.participantCardRole}>Chef de service Informatique, Gestion des Bases de Données et Cartographie</p>
              </div>
            </div>
            
            <div style={styles.participantCard}>
              <div style={styles.participantInfo}>
                <h4 style={styles.participantCardName}>HEZAGIRISHAKA Prosper</h4>
                <p style={styles.participantCardRole}>Cadre au Service Etudes et Statistiques Sociales et Suivi des Indicateurs du Développement</p>
              </div>
            </div>
            
            <div style={styles.participantCard}>
              <div style={styles.participantInfo}>
                <h4 style={styles.participantCardName}>NDIHOKUBWAYO Gloria</h4>
                <p style={styles.participantCardRole}>Responsable du bureau provincial de la Statistique de BUHUMUZA</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    paddingBottom: '25px',
    borderBottom: `2px solid #008D36`,
  },
  title: {
    color: '#008D36',
    fontSize: '1.6rem',
    marginBottom: '15px',
    fontWeight: '400',
    lineHeight: 1.2,
  },
  metaInfo: {
    display: 'flex',
    justifyContent: 'center',
    gap: '30px',
    color: '#666',
    fontSize: '1.1rem',
  },
  date: {
    padding: '5px 15px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
  },
  location: {
    padding: '5px 15px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
  },
  section: {
    marginBottom: '60px',
    padding: '30px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  sectionTitle: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '25px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '400',
  },
  sectionNumber: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '5px 15px',
    borderRadius: '4px',
    marginRight: '15px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  photoContainer: {
    margin: '40px 0',
    textAlign: 'center',
  },
  mainPhoto: {
    width: '100%',
    maxHeight: '500px',
    objectFit: 'cover',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  directorsContainer: {
    margin: '40px auto',
    maxWidth: '800px',
    textAlign: 'center',
  },
  directorsPhoto: {
    width: '100%',
    maxHeight: '400px',
    objectFit: 'cover',
    borderRadius: '8px',
    border: `1px solid #E30613`,
    boxShadow: '0 4px 8px rgba(227, 6, 19, 0.1)',
  },
  photoCaption: {
    marginTop: '10px',
    fontStyle: 'italic',
    color: '#666',
    fontSize: '0.95rem',
  },
  paragraph: {
    marginBottom: '25px',
    textAlign: 'justify',
    fontSize: '1.1rem',
    lineHeight: 1.8,
    color: '#333',
  },
  benefitsSection: {
    marginBottom: '50px',
  },
  subtitle: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '35px',
    fontWeight: '600',
    textAlign: 'center',
  },
  benefitsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '25px',
    marginTop: '30px',
  },
  benefitCard: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    borderTop: `4px solid #008D36`,
  },
  benefitIcon: {
    fontSize: '2.5rem',
    marginBottom: '15px',
  },
  benefitTitle: {
    color: '#008D36',
    fontSize: '1.3rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  benefitText: {
    color: '#666',
    lineHeight: 1.6,
  },
  participantsSection: {
    padding: '30px',
    backgroundColor: 'white',
    borderRadius: '8px',
    marginBottom: '40px',
    borderLeft: `4px solid #E30613`,
  },
  participantsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '20px',
    marginTop: '30px',
  },
  participantCard: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
    display: 'flex',
    alignItems: 'flex-start',
    transition: 'transform 0.3s ease',
    borderTop: '3px solid #008D36',
  },
  participantAvatar: {
    fontSize: '2rem',
    marginRight: '15px',
    backgroundColor: '#f0f0f0',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  participantInfo: {
    flex: 1,
  },
  participantCardName: {
    color: '#008D36',
    fontSize: '1.1rem',
    marginBottom: '8px',
    fontWeight: '600',
  },
  participantCardRole: {
    color: '#666',
    fontSize: '0.95rem',
    lineHeight: 1.5,
  },
};

export default FormationPage;